export interface Currency {
  currencyId: number;
  currencyCode: string;
  currencyDesc: string;
}
